var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.showGenerateButton)?_c('button',{staticClass:"btn btn-red claim-identifier mt-2",attrs:{"disabled":_vm.linkButtonValid},on:{"click":_vm.showModal}},[_vm._v(" "+_vm._s(_vm.linkButtonName)+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }